/*:: import type AccessContext from '../contexts/access-context';*/

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

/* eslint-disable function-paren-newline */

/* eslint-disable object-curly-newline */
const {
  poll
} = require('../../utils/poll');

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

const SocialPostsRepo = require('./social-posts-repo');

const SocialCampaignsRepo = require('./social-campaigns-repo');

const SocialMediaRepo = require('./social-media-repo');

const SocialProfile = require('../../entities/social-profile');

const fields = ['name', 'socialAccounts.type', 'socialAccounts.linked', 'socialAccounts.profileUrl', 'socialAccounts.accountType', 'socialAccounts.refreshRequired', 'timezone', 'enabled', 'created', 'isLinked', 'health', 'config', 'plan', 'brandStyles(id,name,current,restricted)', 'entitlements'];
const listFields = ['id', 'name', 'healthy', 'health', 'socialAccounts.type', 'socialAccounts.linked', 'socialAccounts.profileUrl', 'socialAccounts.accountType', 'socialAccounts.refreshRequired', 'isLinked', 'timezone', 'enabled', 'created'];
const contentFilterFields = ['geoArea', 'tags'];
const configFields = ['postFrequency', 'content.emojiUse', 'content.hashtags', 'content.messageLength', 'branding.style', 'branding.voice', 'branding.colors.primary'];
const statsFields = ['impressions', 'engagement'];

class SocialRepo {
  constructor(client
  /*: ApiClient*/
  , context
  /*: AccessContext*/
  ) {
    this.client = client;
    this.context = context;
    this.posts = new SocialPostsRepo(client, this.context);
    this.campaigns = new SocialCampaignsRepo(client, this.context);
    this.media = new SocialMediaRepo(client, this.context);
  }

  list({
    /*: { healthy: boolean }*/

    healthy = true
  } = {}, options
  /*: RequestOptions*/
  = {}) {
    const path = `/social/profiles`;
    const params = {
      healthy
    };
    const req = new this.client.Request(path, params, options.fields || listFields);
    req.parse = SocialProfile.parse;
    return this.client.get(req);
  }

  getProfile(_
  /*: void*/
  , options
  /*: RequestOptions*/
  = {}) {
    const {
      businessId,
      propertyId
    } = this.context.serialize();
    const path = propertyId ? `/properties/${propertyId}/businesses/${businessId}/social/profile` : `/businesses/${businessId}/social/profile`;
    const req = new this.client.Request(path, undefined, options.fields || fields);
    req.parse = SocialProfile.parse;
    return this.client.get(req);
  }

  getIdeas({
    type
  }, options
  /*: RequestOptions*/
  = {}) {
    const ideaFields = ['id', 'profileId', 'type', 'text', 'meta', 'created'];
    const {
      businessId
    } = this.context.serialize();
    const req = new this.client.Request(`/businesses/${businessId}/social/profile/ideas`, {
      type
    }, options.fields || ideaFields);
    return this.client.get(req);
  }

  createProfile(initParams
  /*: { name: string, timezone: string }*/
  , options
  /*: RequestOptions*/
  = {}) {
    const {
      businessId
    } = this.context.serialize();
    const req = new this.client.Request(`/businesses/${businessId}/social/profile`, {
      name: initParams.name,
      timezone: initParams.timezone
    }, // Why does every route have to allow a different set of fields?
    options.fields || fields.filter(f => f !== 'plan'));
    req.parse = SocialProfile.parse;
    return this.client.post(req);
  }

  updateProfile(profile
  /*: SocialProfile*/
  , options
  /*: RequestOptions*/
  = {}) {
    const {
      businessId
    } = this.context.serialize();
    const req = new this.client.Request(`/businesses/${businessId}/social/profile`, profile, options.fields || fields);
    req.serialize = SocialProfile.serialize;
    req.parse = SocialProfile.parse;
    return this.client.patch(req);
  }

  deleteProfile(_, options
  /*: RequestOptions*/
  = {}) {
    const {
      businessId
    } = this.context.serialize();
    const req = new this.client.Request(`/businesses/${businessId}/social/profile`);
    return this.client.delete(req);
  }

  manageAccounts({
    /*: { redirect?: string }*/

    redirect
  } = {}, options
  /*: RequestOptions*/
  = {}) {
    const {
      businessId
    } = this.context.serialize();
    const req = new this.client.Request(`/businesses/${businessId}/social/profile/ayrshare`, {
      redirect
    }, options.fields || ['url']);
    return this.client.post(req);
  }

  pollForProfileLink() {
    const _this = this;

    return poll(_async(function () {
      return _await(_this.getProfile(undefined, {
        fields: ['isLinked']
      }), function (profile) {
        return profile.isLinked;
      });
    }));
  }

  getContentFilter(_, options
  /*: RequestOptions*/
  = {}) {
    const {
      businessId
    } = this.context.serialize();
    const req = new this.client.Request(`/businesses/${businessId}/social/profile/contentFilter`, undefined, options.fields || contentFilterFields);
    return this.client.get(req);
  }

  updateContentFilter({
    geoArea,
    tags
  }, options
  /*: RequestOptions*/
  = {}) {
    const {
      businessId
    } = this.context.serialize();
    const req = new this.client.Request(`/businesses/${businessId}/social/profile/contentFilter`, {
      geoArea,
      tags
    }, options.fields || contentFilterFields);
    return this.client.patch(req);
  }

  runScheduler({
    /*: {
          soon: boolean,
          notify: boolean,
          periods?: Array<'soon' | 'week1' | 'week2' | 'week3' | 'week4' | 'week5'>,
          flow?: string,
        }*/

    soon,
    notify,
    periods,
    flow
  } = {}) {
    const {
      businessId
    } = this.context.serialize();
    const req = new this.client.Request(`/businesses/${businessId}/social/profile/scheduler/run`, {
      soon,
      notify,
      periods,
      flow
    });
    return this.client.post(req);
  }

  runNotifier() {
    const {
      businessId
    } = this.context.serialize();
    const req = new this.client.Request(`/businesses/${businessId}/social/profile/notifier/run`);
    return this.client.post(req);
  }

  runRevealer() {
    const {
      businessId
    } = this.context.serialize();
    const req = new this.client.Request(`/businesses/${businessId}/social/profile/revealer/run`);
    return this.client.post(req);
  }

  modifyConfig(changeSet, options
  /*: RequestOptions*/
  = {}) {
    const {
      businessId
    } = this.context.serialize();
    const path = `/businesses/${businessId}/social/profile/modifyConfig`;
    const body = {
      changeset: changeSet
    };
    const req = new this.client.Request(path, body, options.fields || configFields);
    return this.client.post(req);
  }

  getStats({
    days,
    postId
  }, options
  /*: RequestOptions*/
  = {}) {
    const {
      businessId
    } = this.context.serialize();
    const path = `/businesses/${businessId}/social/profile/stats`;
    const params = {
      days,
      postId
    };
    const req = new this.client.Request(path, params, options.fields || statsFields);
    return this.client.get(req);
  }

}

module.exports = SocialRepo;